import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  container: {
    borderRadius: '0.5rem',
    border: `1px solid ${neutral[20]}`,
  },

  firstHeading: {
    fontWeight: 600,
    fontSize: '0.625rem',
    lineHeight: '1rem',
    letterSpacing: '0.075rem',
    textTransform: 'uppercase',
    color: neutral[60],
  },

  header: {
    padding: '0.5rem 1rem',
    backgroundColor: neutral[10],
    '& [aria-label="header-title"]': {
      marginBottom: '0.125rem',
    },
    '& [aria-label="item-title"]': {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
    },
  },

  main: {
    padding: '1rem',
    paddingBottom: '1.5rem',
    '& [aria-label="main-title"]': {
      marginBottom: '0.75rem',
    },
  },
  finder: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  searchFieldContainer: {
    position: 'relative',
  },
  inputBase: {
    padding: 0,
    color: neutral[100],
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    '&:hover': {
      backgroundColor: neutral[10],
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${neutral[90]}`,
    },
    '& input': {
      padding: '1.25rem',
      fontSize: '1rem',
      fontWeight: 400,
      // lineHeight: '1.5rem',
      '&[data-is-done="true"]': {
        fontWeight: 600,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: neutral[20],
    },
  },
  clearTextField: {
    width: '-webkit-fill-available',
    maxWidth: 'fit-content',
    padding: '1rem',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[80],
    backgroundColor: neutral[10],
  },
});
